function App() {
  return (
    <div>
      <h1> Nick's Website </h1>
    </div>
  );
}

export default App;
